function init() 
{
   //CSS fix for EXPRESS free shopify theme.
   if(window.theme_store_id == 885) {
   jQuery("head").append("<style type='text/css'>.featured-collections__item .qmp_container{margin-bottom:30px;margin-top:20px;padding:0 2rem;clear:both}.featured-collections__item{margin-top:60px}.quote_items_cart{padding:8px 10px 0 40px}.quote_items_cnt{position:static}.product-form__select-label{padding-top:5px;min-height:4.4rem;padding-bottom:5px;margin:0}</style>");
   }
  
   //Add Request for a Quote Button Dynamically once if shortcode doesn't exists on cart template
    if(window.curr_template == "cart") {
      if(jQuery.inArray(window.theme_store_id, shp_themes) !== -1) {
    		if(!jQuery(".cart_to_quote").length) {
    			jQuery('<a href="javascript:void(0)" class="btn quote_button cart_to_quote">'+window.request_for_a_quote_btn+'</a>').insertBefore("input[name=checkout],button[name=checkout]");
    		}
    	}
    }
	
  	if(window.quick_quote_form_use == "no") {
      	//Add Quote Button on a Products Dynamically even on Load More AJAX events also.
        addQuoteBtn(window.show_button_on,window.curr_template);	
      
      	if(window.show_floating_quote_cart == "yes") {
        	showFloatingCart();
        }
      
      	showQuoteCount();
      	closePopups();
      	qtyIncrement();
      	qtyPress();
        qtyDecrement();
      
      	//Cart to Quote
		cartToQuote();
      
    } else {
		
      quickQuoteBtn(window.show_button_on,window.curr_template);
      showQuickQuoteForm();
      qtyChange();
      submitQuickQuoteForm();
      
      createCookie("quotation_list","", 7);
      
       if(jQuery(".cart_to_quote").length) {
      	jQuery(".cart_to_quote").remove();
       }
    }
  
  	/***
	Here, on product details page - if AJAX recommended section is added by shopify or custom theme have 
    Related or recommended products grid via AJAX then it needs to call on product details page else it does not needed.
    ***/
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;;
           if(typeof MutationObserver === 'function'){
               //  console.log("MutationObserver");
                var timeOut = false;	   
                // Create an observer instance
                var observer = new MutationObserver(function( mutations ) {
                  mutations.forEach(function( mutation ) {

                    var newNodes = mutation.addedNodes; // DOM NodeList

                    if( newNodes !== null ) { // If there are new nodes added
                        var $nodes = jQuery( newNodes ); // jQuery set
                        $nodes.each(function() {
                            var $node = jQuery( this );
                             clearTimeout(timeOut);
                              // do something
                              timeOut = setTimeout(function(){ 
                                if($node.find(".qmp_button_container")) {
                               	if(window.quick_quote_form_use == "no") {
                                	addQuoteBtn(window.show_button_on,window.curr_template); 
                                } else {
                                   quickQuoteBtn(window.show_button_on,window.curr_template);
                                }
                                }
                              }, 100);
                       });
                    }
                  });    
                });

                // Configuration of the observer:
                var config = { 
                      attributes: false,
                      attributeOldValue: false,
                      characterData: false,
                      characterDataOldValue: false,
                      childList: true,
                      subtree: true

                };

                var targetNode = document.body;	
                // Pass in the target node, as well as the observer options
                observer.observe(targetNode, config);

                // Later, you can stop observing
               // observer.disconnect();

           } else {  // fallback on DOMNodeInserted for browser's not supporting MutationObserver API 
			 //  console.log("DOMNodeInserted");
               var timeOut = false;	  
               jQuery(document).on('DOMNodeInserted',window.product_container_element, function(e) {
                 clearTimeout(timeOut); 

                 timeOut = setTimeout(function(){ 
                   if(jQuery(e.target).find(".qmp_button_container")){
                      if(window.quick_quote_form_use == "no") {
                      	addQuoteBtn(window.show_button_on,window.curr_template);  
                      } else {
                         quickQuoteBtn(window.show_button_on,window.curr_template);
                      }
					}
                 }, 100);

               });
     }   
      
  	//Set Opacity Back to Original
  	jQuery("body").css("opacity", 1);
  	jQuery("html").css("opacity",1); 
}
  
//Check if variant  already exists in Cookie or not. 
function current_list_find(var_id) 
{
  if(getCookie("quotation_list") != "") {
    
  	var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list"));  
  	var product = jQuery.grep(getcurrentlist, function(e){ return e.variant_id == var_id; });
  	product = product.length < 1 ? false : product[0];
  	return product;
    
  }
}
  
//Check Inventory on Qty. Change if Enable out of stock setting is disabled
function qtyChange()
{
  if(window.qmp_allow_quote_for_soldout == "no") {
  if(jQuery('input[name=quantity]').length>0) {
  	
    jQuery('input[name=quantity]').on("keyup change blur",function(e) {
     	jQuery('#quote_thank_you_msg').find("#quote_number").html(""); 
   		jQuery("#quote_thank_you_msg").find("#submit_msg").removeClass("err_text success_text").html("");
     	var valid_qty = checkInventory(jQuery(this).val());
  	});
    
  }
  }
}
  
//Get current variant inventory qty. via AJAX Theme Function  
function checkInventory(curr_qty)
{
    var first_variant_id  = jQuery(".qmp_form_container").data("var-id");
    var current_variant_id = getUrlParam("variant");
    var variant_data = "";
                  
    if (typeof current_variant_id === "undefined") {
        current_variant_id = first_variant_id;
    }
    
   	var prd_ajax_url = '/products/'+window.product_handle+'?variant='+current_variant_id+'&view=cws_quote_manage_stock';
  	var stock_response = JSON.parse(
          					jQuery.ajax({
        						url: prd_ajax_url,
        						data: "GET", 
        						async: false
   	 						}).responseText); 
    
  	var maximum_qty = stock_response.current_variant_max;
    
  	if(maximum_qty != -1) {
      if(curr_qty > maximum_qty) {
             if(maximum_qty == 0) {
                jQuery('#stock_msg').addClass("err_text").html(window.out_of_stock_message);
              } else{
               	jQuery('#stock_msg').addClass("err_text").html(window.maximum_qty_msg1+" "+maximum_qty+" "+window.maximum_qty_msg2);
              }
              
              var offsetTop = jQuery('#stock_msg').offset().top - (window.innerHeight / 2);
              jQuery('html, body').animate({ scrollTop: offsetTop }, 800);
  
   			  jQuery('input[name=quantity]').val(maximum_qty);
        	  return false;
  	  } else {
         return true;
      }
    } else {
        jQuery('#stock_msg').html("");
        return true;
    }	
}
  
//Reset form after submit quote
function resetQuickQuoteForm()
{
    jQuery("form#quote_form").trigger("reset"); 
               
    if(jQuery('#captcha_element').length) {
    grecaptcha.reset();
    }
    
    if(jQuery('input[name=quantity]').length > 0) {
    jQuery("input[name=quantity]").val(1);
  	}     
}
  
//Get Re-Captcha  
function loadCaptcha()
{
	if(window.enable_re_captcha == "yes" && window.re_captcha_site_key != "") { 
		var quote_form_recaptcha_widget;
   		if(jQuery('#captcha_element').length) {
          grecaptcha.ready(function() {
          quote_form_recaptcha_widget = 
            	grecaptcha.render(document.getElementById("captcha_element"), {
         		 	'sitekey':window.re_captcha_site_key,
         		 	'theme': "light",
         		 });
           });
    	}
	}
}
    
//Submit Quick Quote Form
function submitQuickQuoteForm()
{
  jQuery(document).on('click','#submit_quick_quote',function(e){
    
    jQuery('#quote_thank_you_msg').find("#quote_number").html("");
    jQuery('#stock_msg').html("");
    jQuery("#quote_thank_you_msg").find("#submit_msg").removeClass("err_text success_text").html("");
    
   	var validation_holder;
	validation_holder=0;
    
    var first_name = jQuery("form#quote_form input[name='first_name']").val() == undefined ? '' : jQuery("form#quote_form input[name='first_name']").val().trim();
	var last_name = jQuery("form#quote_form input[name='last_name']").val() == undefined ? '' : jQuery("form#quote_form input[name='last_name']").val().trim();
	var email = jQuery("form#quote_form input[name='email']").val().trim();
	var phone_number = jQuery("form#quote_form input[name='phone_number']").val() == undefined ? '' : jQuery("form#quote_form input[name='phone_number']").val().trim();
	var message = jQuery("form#quote_form #message").val() == undefined ? '' : jQuery("form#quote_form #message").val().trim();
    var company = jQuery("form#quote_form input[name='company']").val() == undefined ? '' : jQuery("form#quote_form input[name='company']").val().trim();
    var email_reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var phone_reg = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
   
    //First Name
    if(window.required_field.indexOf('first_name') !== -1){
		if(first_name=="") {
			jQuery(".firstname_err").html(window.first_name_error_text);
			validation_holder=1;
		} else {
			jQuery(".firstname_err").html("");
		}
	} 
			
	//Last Name
    if(window.required_field.indexOf('last_name') !== -1){
		if(last_name==""){
			jQuery(".lastname_err").html(window.last_name_error_text);
            validation_holder=1;
		} else {
			jQuery(".lastname_err").html("");
		}
	}
				
	//Email
	if(email==""){
		jQuery(".email_err").html(window.email_error_text);
		validation_holder=1;
	} else{
		if(!email_reg.test(email)){		
			jQuery(".email_err").html(window.invalid_email_error_text);
			validation_holder=1;
		} else {
			jQuery(".email_err").html("");
		} 
	}
			
	//Message
    if(window.required_field.indexOf('message') !== -1){
		if(message==""){
			jQuery(".msg_invalid_err").html(window.message_error_text);
			validation_holder=1;
		} else{
			jQuery(".msg_invalid_err").html("");
		}
	} 
				
	//Phone Number
    if(window.required_field.indexOf('phone_no') !== -1){
		if(phone_number==""){
			jQuery(".phone_err").html(window.phone_error_text);
			validation_holder=1;
          
		} else{
          	if(!phone_reg.test(phone_number)){
              	jQuery(".phone_err").html(window.invalid_phone_error_text);
             	validation_holder=1;
              
            } else {
				jQuery(".phone_err").html("");	
            }
		}
	 } 
				
	//Company
	if(window.required_field.indexOf('company') !== -1){
		if(company ==""){
			jQuery(".company_err").html(window.company_error_text );
			validation_holder=1;
		} else{
			jQuery(".company_err").html("");
		}
	} 
						
	//Re-Captcha
	if(window.enable_re_captcha == "yes" && window.re_captcha_site_key != "") {
		if(grecaptcha.getResponse() == "") {
    		e.preventDefault();
   			jQuery(".captcha_err").html(window.captcha_error_text );
			validation_holder=1;
  		} else {
     		jQuery(".captcha_err").html("");
  		}
	 } 

	 if(validation_holder==1){
		return false;
	 } else {
        var current_product_id  = jQuery(".qmp_form_container").data("prd-id");          
        var prd_handle = jQuery(".qmp_form_container").data("prd-handle");   
        var first_variant_id  = jQuery(".qmp_form_container").data("var-id");
        var current_variant_id = getUrlParam("variant");
        var variant_data = "";
                  
        if (typeof current_variant_id === "undefined") {
        	current_variant_id = first_variant_id;
        }
                           
        //Get Variant Price from API due to Hide Price Feature if enabled.
        var prd_response = jQuery.parseJSON(
          					jQuery.ajax({
        						url: '/products/'+prd_handle+'.js',
        						dataType: "json", 
        						async: false
   	 						}).responseText); 
        
        variant_data = jQuery.grep(prd_response.variants, function (element, index) {
                   			return element.id == current_variant_id;
					   });
				
        var prd_price = variant_data[0].price/100;
		var variant_price_val = prd_price.toFixed(2);
       
       	//Get Qty. val
       	if(jQuery('input[name=quantity]').length > 0) {
    		var prd_qty = parseInt(jQuery("input[name=quantity]").val());
  		} else {
    		var prd_qty = 1;
  		}
       
       	//If Variant is Soldout and RFQ is disabled for Soldout Products then check that condition.
       	var quick_form_data = { shop: window.shop_domain, action: 'submit_quick_quote','first_name':first_name,'last_name': last_name,'email': email,'phone_number':phone_number,'message':message,'company': company, lineitem_product_id: current_product_id, lineitem_variant_id: current_variant_id, lineitem_qty: prd_qty,lineitem_offer_price: variant_price_val,lineitem_product_handle: prd_handle };
          
        if(!variant_data[0].available) {    
          	if(window.qmp_allow_quote_for_soldout == "no") {
              	
              	resetQuickQuoteForm();
              	
              	jQuery('#quote_thank_you_msg').find("#submit_msg").removeClass("success_text").addClass("err_text").html(window.soldout_message);
              	var offsetTop = jQuery('#quote_thank_you_msg').offset().top - (window.innerHeight / 2);
                jQuery('html, body').animate({ scrollTop: offsetTop }, 800);	
              
            } else {
              
              jQuery.ajax({
    	  		url:  window.data_url,
          		type: "POST",
                data: quick_form_data,
          		dataType: 'jsonp',
                success: function(res){
                     
                if(res.html == "succ") { 
                  	
                  	resetQuickQuoteForm();
           			
                    jQuery("#quote_thank_you_msg").find("#submit_msg").removeClass("err_text").addClass("success_text").html(window.thank_you_msg);
                  	jQuery("#quote_thank_you_msg").find("#quote_number").html(": "+res.quote_id);
                    
                  	var offsetTop = jQuery('#quote_thank_you_msg').offset().top - (window.innerHeight / 2);
                    jQuery('html, body').animate({ scrollTop: offsetTop }, 800);   
                }
              }
              });
            }
        } else {
          var valid_qty = true;
		  
          if(window.qmp_allow_quote_for_soldout == "no") {
          	valid_qty = checkInventory(prd_qty);
          }
          
          if(valid_qty) {
            jQuery.ajax({
    	  		url:  window.data_url,
          		type: "GET",
                data: quick_form_data,
          		dataType: 'jsonp',
    		    success: function(res){
              
              	if(res.html == "succ") {  
                  	resetQuickQuoteForm();
                  
                	jQuery("#quote_thank_you_msg").find("#submit_msg").removeClass("err_text").addClass("success_text").html(window.thank_you_msg);
                	jQuery("#quote_thank_you_msg").find("#quote_number").html(": "+res.quote_id);
                  	var offsetTop = jQuery('#quote_thank_you_msg').offset().top - (window.innerHeight / 2);
                	jQuery('html, body').animate({ scrollTop: offsetTop }, 800);     	
                }
                }
             }); 
           }
         }
      }
  });
}
  
//Add dynamic "Add to Quote" Btn
function addQuoteBtn(show_button_on,curr_template) 
{
  var disabled_ids_array = new Array();
  
  disabled_ids_array = window.qmp_pro_ids.toString().split(',');
 
  //Hide Price on All Products - 786
  if(window.hide_price == 0) {
    jQuery(window.price_selectors).remove();
    jQuery("[id=quote-price]").remove();
  }
  
  //Hide Add to Cart on All Products - 786
  if(window.hide_addtocart == 0) {
  	jQuery(window.addtocart_selectors).remove();
  }
     
  //Current page is: collection and setting is > show on products only then hide on collection page.- 786
  var quote_btn = "";
  var btn_css = "";
  if(show_button_on == "show_on_products" && curr_template == "collection") {
  btn_css = 'display:none;';
  }
 
  //Loop through our Define endpoint around each Product then add button dynamically.
  jQuery('[id^=qmp-collection-script-]').each(function(index,value) {
    var prd_id = jQuery(this).attr("data-id");
    var prd_handle = jQuery(this).attr("data-prd-handle");
    var var_id = jQuery(this).attr("data-var-id");
      
    if(jQuery.inArray(prd_id,disabled_ids_array) === -1){
    
      quote_btn = '<button data-prd-handle="'+prd_handle+'" data-prdid="'+prd_id+'" data-varid="'+var_id+'" type="button" name="add_to_quote" class="btn quote_button quote_options" style="'+btn_css+'">'+window.add_to_quote_btn+'</button>';
      
      if (jQuery("#qmp_button_container_"+prd_id).children('.quote_options').length == 0) {
      	
         	//Append Btn HTML
       	 	var child = jQuery(quote_btn);
   	  		jQuery("#qmp_button_container_"+prd_id).append(child);
        
          	//IMPORTANT! to attach click event
			child.click(function(event) 
           	{
				event.stopImmediatePropagation();
				event.stopPropagation();
				event.preventDefault();

				loadVariantPopup(prd_handle);				
				return false;
			});
      }
 
     //Hide Add to Cart on Quote Enabled Products only - 786
     if(window.hide_addtocart == 1) {
     	jQuery('script[data-id="' + prd_id + '"]').closest(window.product_container_ele).find(window.addtocart_selectors).remove();
     }
      
     //Hide Price on Quote Enabled Products only - 786
     if(window.hide_price == 1) {
       jQuery('script[data-id="' + prd_id + '"]').closest(window.product_container_ele).find(window.price_selectors).remove();  
     }
      
     //Hide qty. box on Quote Enabled Products only - 786/92/313/ASM
     jQuery('script[data-id="' + prd_id + '"]').closest(window.product_container_ele).find(window.qty_selectors).remove(); 

    /*** Hide variant dropdown on quote enabled products only but when hide add to cart is 'yes'. 
    Due to if hide add to cart is 'no' and we've hide these dropdowns then 
    how user can add item in cart for specific variant? - so.- 786/92
    ***/
     if(window.hide_addtocart != 2) {
     jQuery('script[data-id="' + prd_id + '"]').closest(window.product_container_ele).find(window.variant_dropdown_selectors).hide(); 
     }
    }
  });
}
 
//Show Quick Quote Button
function quickQuoteBtn(show_button_on,curr_template) 
{
  var disabled_ids_array = new Array();
  
  disabled_ids_array = window.qmp_pro_ids.toString().split(',');
 
  //Hide Price on All Products - 786
  if(window.hide_price == 0) {
  	jQuery(window.price_selectors).remove();
  }
  
  //Hide Add to Cart on All Products - 786
  if(window.hide_addtocart == 0) {
  	jQuery(window.addtocart_selectors).remove();
  }
  
  //Current page is: collection and setting is > show on products only then hide on collection page.- 786
  var quote_btn = "";
  var btn_css = "";
  
  if(show_button_on == "show_on_products" && curr_template == "collection") {
  btn_css = 'display:none;';
  }
  
  //Loop through our Define endpoint around each Product then add button dynamically.
  jQuery('[id^=qmp-collection-script-]').each(function(index,value) {
  	var prd_id = jQuery(this).attr("data-id");
    var prd_handle = jQuery(this).attr("data-prd-handle");
    var var_id = jQuery(this).attr("data-var-id");
    var prd_available = jQuery(this).attr("data-prd-available");
    
    if(jQuery.inArray(prd_id,disabled_ids_array) == -1){

        if(prd_available) {
			var is_disabled = "no";
            quote_btn = '<button data-prd-handle="'+prd_handle+'" data-prdid="'+prd_id+'" data-varid="'+var_id+'" type="button" name="add_to_quote" class="btn quote_button add_to_quote" style="'+btn_css+'">'+window.add_to_quote_btn+'</button>';
        } else {
          if(window.qmp_allow_quote_for_soldout != "") {
          
            if(window.qmp_allow_quote_for_soldout == "yes") {
			var is_disabled = "no";
	       	quote_btn = '<button data-prd-handle="'+prd_handle+'" data-prdid="'+prd_id+'" data-varid="'+var_id+'" type="button" name="add_to_quote" class="btn quote_button add_to_quote" style="'+btn_css+'">'+window.add_to_quote_btn+'</button>';
 
            } else {
			var disabled = "yes";
            quote_btn = '<button data-prd-handle="'+prd_handle+'" data-prdid="'+prd_id+'" data-varid="'+var_id+'" type="button" name="add_to_quote" class="btn quote_button add_to_quote disabled" style="'+btn_css+'" disabled>'+window.soldout+'</button>';
            }
         } else {
			var is_disabled = "yes";
            quote_btn = '<button data-prd-handle="'+prd_handle+'" data-prdid="'+prd_id+'" data-varid="'+var_id+'" type="button" name="add_to_quote" class="btn quote_button add_to_quote disabled" style="'+btn_css+'" disabled>'+window.soldout+'</button>'; 
         }
      }
		
	 if(curr_template != "product") {
      	if (jQuery("#qmp_button_container_"+prd_id).children('.add_to_quote').length == 0) {
         	//Append Btn HTML
        	var child = jQuery(quote_btn);
   	  		jQuery("#qmp_button_container_"+prd_id).append(child);
        
			//IMPORTANT! to attach click event
			child.click(function(event) {
				event.stopImmediatePropagation();
				event.stopPropagation();
              	window.location.href = "https://"+window.shop_domain+"/products/"+prd_handle;
			});
     	 }
	}
		
     //Hide Add to Cart on Quote Enabled Products only - 786
     if(window.hide_addtocart == 1) {
     	jQuery('script[data-id="' + prd_id + '"]').closest(window.product_container_ele).find(window.addtocart_selectors).remove();
     }
      
     //Hide Price on Quote Enabled Products only - 786
     if(window.hide_price == 1) {
     	jQuery('script[data-id="' + prd_id + '"]').closest(window.product_container_ele).find(window.price_selectors).remove();
     }
	}
  });
}
 
//Show Quick Quote Form on Product Page  
function showQuickQuoteForm()
{
  if(window.curr_template == "product") {
    
    var disabled_ids_array = new Array();
  	var prd_id = jQuery('[id^=qmp-collection-script-]').attr("data-id");
    
  	disabled_ids_array = window.qmp_pro_ids.split(',');
 
    var data = { shop: window.shop_domain, action: 'show_qoute_product_form', first_name_lbl: window.first_name_lbl, last_name_lbl: window.last_name_lbl, email_lbl: window.email_lbl, message_lbl: window.message_lbl, phone_no_lbl: window.phone_no_lbl, company_lbl: window.company_lbl, submit_quote_lbl: window.submit_quote_lbl, cust_first_name: window.cust_first_name, cust_last_name: window.cust_last_name, cust_email: window.cust_email, cust_phone: window.cust_phone };
    
    jQuery.ajax({
			type: "POST",
    		dataType: 'jsonp',
      		url:  window.data_url,
			data:data,
			success: function(res) {
              
	          if(res.access_status != "Unauthorized") {
                 //If Quote is disabled on Product then Hide Quote Submit Form
                if(jQuery.inArray(prd_id,disabled_ids_array) == -1){
              		jQuery("#qmp_form_container_"+prd_id).html(res.html);
                   loadCaptcha();
                }
	          } else {
				jQuery("#qmp_form_container_"+prd_id).html("");
              }
			}	
	 });	
  }
}
  
  
//Allowed to type number only for qty. box of vraint table.
function qtyPress()
{
	jQuery(document).on('keypress','.cws-number-only',function(evt) {
    	var isno = qtyisNumber(evt);
    
       	if(!isno) {
        	return false;
       	}
    });
}
  
//Qty. decrement
function qtyDecrement()
{
	jQuery(document).on('click','[id^=qtyminus]',function() {     
       	var ele_id = jQuery(this).siblings(".cws-number-only").attr('id');
        var variant_id = ele_id.replace("cws_", "");
     	var qtyInput = jQuery("#"+ele_id);
  		var currentVal = parseInt(qtyInput.val());
    
       if(currentVal > 0) {
      	   qtyInput.val(currentVal - 1);
   		 } 
	}); 
} 
  
//Qty. increment
function qtyIncrement() 
{
    jQuery(document).on('click','[id^=qtyplus]',function() {     
    	var ele_id = jQuery(this).siblings(".cws-number-only").attr('id');
        var variant_id = ele_id.replace("cws_", "");
     	var qtyInput = jQuery("#"+ele_id);
  		var currentVal = parseInt(qtyInput.val());
      
      	if(jQuery.isNumeric(currentVal)) {
  			qtyInput.val(currentVal+1);	
        }
	});  
}
  
//Show Floating Side Quote Cart
function showFloatingCart() 
{
  var param_val = getUrlParam('page');
  if(param_val == "quote_accept") {
    jQuery(".sticky_qmp_cart").html("");
  } else {
    jQuery(".sticky_qmp_cart").html('<a title="'+window.view_quote_text+'" id="flyToCart" class="qmp_quote_cart" href="/apps/quote-request"><div id="quote_cart_div" class="quote_items_cart"><p><sup class="quote_items_cnt"></sup></p></div></a>');
  }
}
  
//Load Variants in Popup for Collection Page & Variant Chooser Methods
function loadVariantPopup(prd_handle) 
{
    jQuery(".qmp_variant_list").css('display','block');
    jQuery(".qmp_variant_list .qmp_modal_body").show();
    jQuery(".qmp_variant_list .qmp_modal_footer").show();
    jQuery(".qmp_variant_list .qmp_loader").show();
  
  	if(/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
    	var qty_type = 'number';  
   	} else {                       
    	var qty_type = 'text';
    }
  
  	var table_default_qty = parseInt(jQuery.trim(window.variant_table_default_qty));
 
	//Show Variant Image as per setting.
    if(window.show_variant_img == "yes") {
    	jQuery('head').append('<style type="text/css">@media only screen and (max-width:767px) {#qmp-cws-variants-tbl #variants thead{ display:none;} #qmp-cws-variants-tbl #variants td.prd_name:before { content: "'+window.prd_name+'"; } #qmp-cws-variants-tbl #variants td.prd_price:before { content: "'+window.prd_price+'"; } #qmp-cws-variants-tbl #variants td.prd_qty:before { content: "'+window.prd_qty+'"; } #variants td.prd_img:before { content: "'+window.prd_img+'"; }}</style>'); 
	} else {
      jQuery('head').append('<style type="text/css">@media only screen and (max-width:767px) {#qmp-cws-variants-tbl #variants thead{ display:none;} #qmp-cws-variants-tbl #variants td.prd_name:before { content: "'+window.prd_name+'"; } #qmp-cws-variants-tbl #variants td.prd_price:before { content: "'+window.prd_price+'"; } #qmp-cws-variants-tbl #variants td.prd_qty:before { content: "'+window.prd_qty+'"; }}</style>'); 
	}
  
    jQuery.getJSON('/products/'+prd_handle+'.js',function(product) {
      	var prd_id = product.id;
    	var var_id = product.variants[0].id;
   
      	jQuery(".qmp_variant_list .qmp_loader").hide();
      
      	//Get product title
		var product_title = product.title;
      
      	//Get product options
      	var option1_title = "";
       	var option2_title = "";
       	var option3_title = "";
      
      	if(product['options'].hasOwnProperty(0)) {
  			option1_title = product['options'][0]['name'];
		}
 
      	if(product['options'].hasOwnProperty(1)) {
  			option2_title = product['options'][1]['name'];
		}
  
      	if(product['options'].hasOwnProperty(2)) {
  			option3_title = product['options'][2]['name'];
		}
      
      	//Get product variants
		var variants = product['variants'];
        if(window.location.href.split("?")[1]) {
          var variantId = window.location.href.split("?")[1].split("=")[1];
          var foundVariant = {};
          product["variants"].forEach(function(variant) { if(variant.id === parseInt(variantId)) { foundVariant = variant } });
          variants = [foundVariant];
        }
		var variant_count =variants.length;
      	var html = "";

		//Variant table that needs to be appended.
		html+="<table border='2' id='variants'><thead><tr><th>"+window.prd_name+"</th>";
      
      	//Show Variant Image as per setting.
      	if(window.show_variant_img == "yes") {
          
          var images_res = JSON.parse(
          					jQuery.ajax({
        						url: '/products/'+prd_handle+'/images.json',
        						data: "GET", 
        						async: false
   	 						}).responseText); 
          var prd_images = images_res['product']['images'];
          var variant_img_size = jQuery.trim(window.variant_img_size);
          
          html+="<th>"+window.prd_img+"</th>";
      	}
      	
      	//If Hide Price setting will set as 'no' then only show price value.
      	if(window.hide_price == 2) {
      		html+="<th>"+window.prd_price+"</th>";
       	}
      
      	html+="<th>"+window.prd_qty+"</th></thead></tr><tbody>";

      	for(var i=0;i<variant_count;i++)
		{		
				var var_id = variants[i]['id'];
				var var_sku = variants[i]['sku'];
				var var_price = variants[i]['price'];
				var var_compare_price = variants[i]['compare_at_price'];
				var var_available= variants[i].available;
          
          		//Get Variant Option Values
				var option1_val = variants[i]['option1'];
				var option2_val = variants[i]['option2'];
				var option3_val = variants[i]['option3'];
          
          		html+="<tr><td class='prd_name'>";     
             	html+="<p>"+product_title+"</p>";
              
              	//Append Variant Options
          		if(option1_title != "Title" && option1_val != "Default Title")
                {
					if(product['options'].hasOwnProperty(0) == true && option1_val != "")
					{
					html+="<p><b>"+option1_title+":</b> "+option1_val+"</p>";
					}
					if(product['options'].hasOwnProperty(1) == true && option2_val != "")
					{
					html+="<p><b>"+option2_title+":</b> "+option2_val+"</p>";
					}		
					if(product['options'].hasOwnProperty(2) == true  && option3_val != "")
					{
					html+="<p><b>"+option3_title+":</b> "+option3_val+"</p>";
					}
                }
              
              	//Append Variant SKU.
				if(var_sku != "" && var_sku != null) {
                  	if(window.show_sku == "yes") {
						html+="<p><b>"+window.sku_text+":</b> "+var_sku+"</p>";		
                    }
				}
          
				html+="</td>";
          
          		//Show Variant Image as per setting.
      			if(window.show_variant_img == "yes") {
                  var var_img = "";
                  var final_var_img = "";
                  
                  for(var p=0;p<prd_images.length;p++)
                  {
                  	if(jQuery.inArray(var_id, prd_images[p]['variant_ids']) !== -1) {
                    var_img = prd_images[p]['src'];
                    }
                  }
                  
                  if(var_img == "") {
                     if(product.featured_image == null) {
                       var_img = window.no_img;
                     } else {
                       var_img = product.featured_image;
                     }
            	   }
	              
			 		//For smaller size image to load - 786  
                  	if(var_img != null) {
             			var img_without_extension = var_img.substr(0, var_img.lastIndexOf('.')) || var_img;
            			var img_ext = var_img.split('.').pop();
             			img_ext = img_ext.substring(0, img_ext.indexOf('?'));
             			final_var_img = img_without_extension+"_"+variant_img_size+"."+img_ext;
                    } 
			 		//Ended Here - 786
                             
          			html+="<td class='prd_img'><img src='"+final_var_img+"' class='cws_var_imgs'/></td>";
      			}
             
              	//Prices
      			var sale_percent = "";
     
      			//If Hide Price setting will set as 'no' then only show price value.
      			if(window.hide_price == 2) {
  
      			if(var_compare_price != "") {
      	
        		if(var_compare_price>var_price) {                      
          			sale_percent = (var_compare_price-var_price)*100/var_compare_price;
       	 			sale_percent = sale_percent.toFixed(2);
            		sale_percent = Math.round(sale_percent);
          	
          			html+="<td class='prd_price'><span class='money compare var_compare_price'>"+Shopify.formatMoney(var_compare_price, qmp_money_format)+"</span>";
            		html+="<p><span class='money var_price'>"+Shopify.formatMoney(var_price, qmp_money_format)+"</span></p>";
          			html+="<p><span class='badge--sale'>"+window.var_save_label+" <span>"+sale_percent+"</span>%</span></p>";	
       	
       	 		} else {
          			sale_percent = "";
          			html+="<td class='prd_price'><span class='money'>"+Shopify.formatMoney(var_price, qmp_money_format)+"</span><br/>";
        		}
      		 } else {
       			sale_percent = "";
        		html+="<td class='prd_price'><span class='money'>"+Shopify.formatMoney(var_price, qmp_money_format)+"</span><br/>";
      		 }
         	} 
              
          	html+="</td>";
             
    		//Show Soldout if product is not available
    		if(var_available) { 
              	jQuery(".variant_quote_submit").removeClass('disabled');
                jQuery(".variant_quote_submit").prop("disabled", false);
              
           		html+="<td class='prd_qty'><div class='qty-box'><input style='cursor:pointer;' id='qtyminus_"+var_id+"' class='qtyminus' type='button' value='-'><input type='"+qty_type+"' name='qty' value='"+table_default_qty+"' class='cws-number-only' id='cws_"+var_id+"' size='5' data-variantid='"+var_id+"' data-productid='"+prd_id+"' />";	
				html+="<input style='cursor:pointer;' id='qtyplus_"+var_id+"' class='qtyplus' type='button' value='+'>";
				html+="</div></td>";
         
    		} else {
          		if(window.qmp_allow_quote_for_soldout == "no") {  
        	   		
                  	html+="<td class='prd_qty'><span class='out_of_stock'>"+window.soldout+"</span></td>";
                  
                  	//If only "1" variant and it's soldout then disable "submit quote" button.
                   if(variant_count == 1) {
                     	jQuery(".variant_quote_submit").addClass('disabled');
                     	jQuery(".variant_quote_submit").prop("disabled", true);
                   } else {
                    	jQuery(".variant_quote_submit").removeClass('disabled');
                     	jQuery(".variant_quote_submit").prop("disabled", false);
                   }
                  	
            	} else {
                  	jQuery(".variant_quote_submit").removeClass('disabled');
                    jQuery(".variant_quote_submit").prop("disabled", false);
                  
               		html+="<td class='prd_qty'><div class='qty-box'><input style='cursor:pointer;' id='qtyminus_"+var_id+"' class='qtyminus' type='button' value='-'><input type='"+qty_type+"' name='qty' value='"+table_default_qty+"' class='cws-number-only' id='cws_"+var_id+"' size='5' data-variantid='"+var_id+"' data-productid='"+prd_id+"'/>";
					html+="<input style='cursor:pointer;' id='qtyplus_"+var_id+"' class='qtyplus' type='button' value='+'>";
					html+="</div></td>";
            	}
    	    }
           
			html+="</tr>";
            }
      
      		html+="</tbody></table>";
      		
      		//Append Variant Table.
      		jQuery("#qmp-cws-variants-tbl").html(html);
  	});        
}
 
//Close modal popup
function closePopups() 
{
	jQuery(document).on("click",'.qmp_modal_close,.qmp_footer_modal_close,.continue_btn',function() 
	{
    	jQuery('.qmp_modal').css('display','none');
   	 	jQuery(".qmp_variant_list .qmpproduct_options").find(".qmp_product_option").html("");
  		jQuery("#qmp_message .qmp_modal_body").find(".prd_msg").html("");
	});
 
	jQuery(document).bind("click touchend",function(e)
	{
   		if(jQuery('.qmp_modal').is(e.target)) {    
     		jQuery('.qmp_modal').css('display','none');
     		jQuery(".qmp_variant_list .qmpproduct_options").find(".qmp_product_option").html("");
     		jQuery("#qmp_message .qmp_modal_body").find(".prd_msg").html("");
		}
	});
}
  
//Add Quotation Items in Quote Cart
function addToQuote() 
{
if(window.quick_quote_form_use == "no") { 
  
var quotation_list = "";
var prd_id = "";
var var_id = "";
var qty = "";
var not_added = 0;
var rows_len = jQuery('#qmp-cws-variants-tbl .cws-number-only').length;
  
jQuery('#qmp-cws-variants-tbl .cws-number-only').each(function() {
   prd_id = jQuery(this).attr("data-productid");
   var_id = jQuery(this).attr("data-variantid");
   qty = parseInt(jQuery(this).val());
  
  if(qty>0) {
   quotation_list = [{ 'product_id': prd_id,'variant_id': var_id,'qty': qty }];
  
   if(getCookie("quotation_list") == "") {
    
  	createCookie("quotation_list",JSON.stringify(quotation_list), 7);
     
   } else { 
    var product = current_list_find(var_id);
   
    if(product) {
		var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list")); 
    	var returnedData = jQuery.grep(getcurrentlist,function(obj) {
      	
         if(obj.variant_id == var_id) {
      		obj.qty = parseInt(obj.qty)+qty;   
      	 }
      
       	  return obj;
		});
   
    	createCookie("quotation_list",JSON.stringify(returnedData), 7);
   } else {
      	var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list"));
      	getcurrentlist.push({ 'product_id': prd_id,'variant_id': var_id,'qty': qty }); 
   		createCookie("quotation_list",JSON.stringify(getcurrentlist),7);
    }
  }
  } else {
    not_added++;
  }
  });
   
  //Show success message dialog
  if(rows_len != not_added) {
  	jQuery(".qmp_variant_list").css('display','none');
  	jQuery("#qmp_message").css('display','block');
  	jQuery("#qmp_message .qmp_modal_body").fadeIn(1000);
  	jQuery("#qmp_message .qmp_modal_body").find(".prd_msg").html(window.add_to_quote_success_message);
  }
  
 } else {
   
    if(window.curr_template == "product") {
  		if(jQuery('input[name=quantity]').length > 0) {
    		var qty = parseInt(jQuery("input[name=quantity]").val());
  		} else {
    		var qty = 1;
  		}
 	}
 }
                                             
  //Update Quote items count in sticky cart.
  showQuoteCount();
}
  
//On click of Add to Quote Button From Variant Chooser Popup
jQuery(document).on('click','.variant_quote_submit',function(e){
  e.preventDefault();
  addToQuote();
});
  
//Cart to Quote - [Add Cart Items in Quoatation with Single Button Click]
function cartToQuote() 
{
  jQuery(document).on("click",'.cart_to_quote',function() {
   
    var pro_ids_arr = [];
    
    if(window.qmp_pro_ids != "") {
    	var pro_ids = jQuery.trim(window.qmp_pro_ids);
    	pro_ids_arr =  pro_ids.toString().split(',');
    }
    
    jQuery.getJSON('/cart.js').done(function(cart) {
     
      for(var j=0; j<cart.items.length;j++) {
       
      	var quotation_list = [{ 'product_id': cart.items[j].product_id,'variant_id': cart.items[j].id,'qty': cart.items[j].quantity }];
      
     	if(pro_ids_arr.length>0){
          
        if(jQuery.inArray(cart.items[j].product_id.toString(), pro_ids_arr) == -1) {
         
        	if(getCookie("quotation_list") == "") {
              
  				createCookie("quotation_list",JSON.stringify(quotation_list), 7);
              
  			} else { 
				
            
            var product = current_list_find(cart.items[j].id);
   
    		if(product) {
				var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list")); 
    			var returnedData = jQuery.grep(getcurrentlist,function(obj) {
      	
          		if(obj.variant_id == cart.items[j].id) {
      				obj.qty = parseInt(obj.qty)+parseInt(cart.items[j].quantity);   
      	 		}
                  
               	return obj;
				});
   
    			createCookie("quotation_list",JSON.stringify(returnedData), 7);
      
   			} else {
     
      			var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list"));
      			getcurrentlist.push({ 'product_id': cart.items[j].product_id,'variant_id': cart.items[j].id, 'qty': cart.items[j].quantity }); 
   	
   				createCookie("quotation_list",JSON.stringify(getcurrentlist),7);
    		}  
          }
        }
        } else {
          	if(getCookie("quotation_list") == "") {
  				
              createCookie("quotation_list",JSON.stringify(quotation_list), 7);
  			
            } else {   
			
            var product = current_list_find(cart.items[j].id);
   
    		if(product) {
				var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list")); 
    			var returnedData = jQuery.grep(getcurrentlist,function(obj) {
      	
          		if(obj.variant_id == cart.items[j].id) {
      				var quote_qty = parseInt(obj.qty)+parseInt(cart.items[j].quantity)
                    obj.qty = quote_qty;
      	 		}
                  
               	return obj;
				});
   
    			createCookie("quotation_list",JSON.stringify(returnedData), 7);
      
   			} else {
     
      			var getcurrentlist = jQuery.parseJSON(getCookie("quotation_list"));
      			getcurrentlist.push({ 'product_id': cart.items[j].product_id,'variant_id': cart.items[j].id, 'qty': cart.items[j].quantity }); 
   	
   				createCookie("quotation_list",JSON.stringify(getcurrentlist),7);
    		}
          }
        }
      }
      
      //Redirect to Request for a Quote - Products Listing Page
      window.location.href= '/apps/quote-request'; 
    });
  });
}
 
//Show Quote Count
function showQuoteCount() 
{  
  	var items_cnt = 0;
 	var getcurrentlist = getCookie("quotation_list");
 
  	if(getcurrentlist != "") {
    	getcurrentlist = jQuery.parseJSON(getcurrentlist);
	  	if(getcurrentlist.length > 0) {
    		for (var k = 0; k < getcurrentlist.length; k++) {
   			items_cnt += getcurrentlist[k].qty; 
			}
	  	} else {
		  	items_cnt = 0;
	  	}
  	} else {
   		items_cnt = 0;
  	}
		
 	jQuery("#quote_cart_div").find(".quote_items_cnt").html("("+items_cnt+")");
}
  
//Store Quote Items in Cookie
function createCookie(name, value, days) 
{
    if(days) 
    {
         var date = new Date();
         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
         var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";               
    document.cookie = name + "=" + value + expires + "; path=/";
	//document.cookie = name + "=" + value + expires + "; path=/;SameSite=Lax";
}

//Get Quote Items From Cookie
function getCookie(cname) 
{
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
  
//Check Qty. is number or not.
function qtyisNumber(evt)
{
  	evt = (evt) ? evt : window.event;
   	var charCode = (evt.which) ? evt.which : evt.keyCode;
    	
	if(charCode > 31 && (charCode < 48 || charCode > 57)) {
    	return false;
    }
   	return true;
}
 
//Get Query String Parameter Value
function getUrlParam(sParam) 
{
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

//For Hide Add to Cart Button dynamically will be not displayed then remove instantly kind of effect
var elem = document.getElementsByTagName("html")[0];
elem.style.opacity = 0;

//App Initialized - 786/ASKMPFNAJDMR
jQuery(document).ready(function() {

  	var jqscriptobj = jQuery("script");

	if(jqscriptobj.text().indexOf("cws_quotation_init.js?") != -1 && jqscriptobj.text().indexOf("asyncLoad") != -1 && jqscriptobj.text().indexOf("initSchema") == -1) {
      	
      if(window.enable_app == "yes") {
      	init(); 
      } else {
        jQuery("body").css("opacity", 1);
    	jQuery("html").css("opacity", 1);
      }
   } else {
      	jQuery("body").css("opacity", 1);
    	jQuery("html").css("opacity", 1);
   }
});